import * as React from "react";
const SvgMarkerPin01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.965 10a6.965 6.965 0 1 0-13.93 0c0 1.881.848 3.66 2.285 5.525 1.273 1.653 2.918 3.267 4.68 5.015 1.762-1.748 3.407-3.362 4.68-5.015 1.437-1.866 2.285-3.644 2.285-5.525m-5 0a1.965 1.965 0 1 0-3.93 0 1.965 1.965 0 0 0 3.93 0m2.07 0a4.035 4.035 0 1 1-8.07 0 4.035 4.035 0 0 1 8.07 0m5 0c0 2.537-1.152 4.759-2.715 6.788-1.553 2.016-3.623 3.978-5.589 5.943a1.034 1.034 0 0 1-1.462 0c-1.966-1.965-4.036-3.927-5.59-5.943-1.562-2.03-2.714-4.25-2.714-6.788a9.035 9.035 0 0 1 18.07 0"
}));
export default SvgMarkerPin01;
//# sourceMappingURL=MarkerPin01.js.map